/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixEcommerceSubscriptions = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var WixEcommerceSubscriptions = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        SubscriptionsApi: function () {
            return function (headers) {
                var service = {
                    createSubscription: function (createSubscriptionRequest) {
                        return httpClient.invoke('POST', '/v1/subscriptions', createSubscriptionRequest, headers);
                    },
                    getSubscription: function (getSubscriptionRequest) {
                        return httpClient.invoke('GET', '/v1/subscriptions/{id}', getSubscriptionRequest, headers);
                    },
                    updateShippingAddress: function (updateShippingAddressRequest) {
                        return httpClient.invoke('POST', '/v1/subscriptions/{id}/updateShippingAddress', updateShippingAddressRequest, headers);
                    },
                    updateTotals: function (updateTotalsRequest) {
                        return httpClient.invoke('POST', '/v1/subscriptions/{id}/updateTotals', updateTotalsRequest, headers);
                    },
                };
                service.createSubscription.__http_method = 'POST';
                service.createSubscription.__http_url = '/v1/subscriptions';
                service.getSubscription.__http_method = 'GET';
                service.getSubscription.__http_url = '/v1/subscriptions/{id}';
                service.updateShippingAddress.__http_method = 'POST';
                service.updateShippingAddress.__http_url = '/v1/subscriptions/{id}/updateShippingAddress';
                service.updateTotals.__http_method = 'POST';
                service.updateTotals.__http_url = '/v1/subscriptions/{id}/updateTotals';
                return service;
            };
        },
    };
};
exports.WixEcommerceSubscriptions = WixEcommerceSubscriptions;
exports.WixEcommerceSubscriptions.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map